function popupRules(app) {
  return {
    ownerName: [
      {
        max: 50,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.popup.system.owner.label.ownerName'),
          length: 50
        }),
        trigger: 'blur'
      }
    ],
    ownerExId: [
      {
        max: 20,
        trigger: 'blur',
        message: app.$t('message.common.validation.size', {
          field: app.$t('label.popup.system.owner.label.ownerExId'),
          length: 20
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.popup.system.owner.label.ownerExId'),
          type: '半角英数字'
        })
      }
    ],
  }
}

export default {
  popupRules: popupRules
}
